export default [{
  name: 'pendingRegulatoryRestaurants',
  path: 'pendingRegulatoryRestaurants',
  component: () => import('./PendingRegulatoryRestaurants.vue'),
  meta: {
    title: '未监管餐厅'
  }
}]



// WEBPACK FOOTER //
// ./src/router/pending_regulatory_restaurants/index.js